<header class="page-header">
    <div>
        <h1 class="page-header__title">{{ 'authentication.resetPassword.title' | translate }}</h1>
        <p class="page-header__description">{{ 'authentication.resetPassword.description' | translate }}</p>
    </div>
</header>
<form class="form-grid" [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
    <div class="form-field">
        <label for="reset-email" class="form-field__label">{{
            'authentication.resetPassword.form.email' | translate
        }}</label>
        <p-iconfield>
            <p-inputicon styleClass="ms ms-mail" />
            <input
                id="reset-email"
                [placeholder]="'authentication.common.placeholder.email' | translate"
                type="text"
                formControlName="email"
                pInputText
                [fluid]="true" />
        </p-iconfield>
    </div>
    <div class="form-field">
        <label for="reset-code" class="form-field__label form-field__label--required">{{
            'authentication.resetPassword.form.verificationCode' | translate
        }}</label>
        <p-iconfield>
            <p-inputicon styleClass="ms ms-pin" />
            <input
                id="reset-code"
                [placeholder]="'authentication.common.placeholder.code' | translate"
                type="text"
                formControlName="code"
                autocomplete="off"
                pInputText
                pKeyFilter="int"
                [maxlength]="6"
                [fluid]="true" />
        </p-iconfield>
        @if (f.code.touched && f.code.errors?.required) {
            <small class="p-error">{{ 'authentication.resetPassword.validation.requiredCode' | translate }}</small>
        } @else if (f.code.touched && f.code.invalid) {
            <small class="p-error">{{ 'authentication.resetPassword.validation.invalidCode' | translate }}</small>
        }
    </div>
    <div class="form-field">
        <label for="reset-new-password" class="form-field__label form-field__label--required">{{
            'authentication.resetPassword.form.newPassword' | translate
        }}</label>
        <p-iconfield>
            <p-inputicon styleClass="ms ms-key" />
            <input
                id="reset-new-password"
                [placeholder]="'authentication.common.placeholder.newPassword' | translate"
                type="password"
                formControlName="newPassword"
                autocomplete="off"
                pInputText
                [fluid]="true"
                [pTooltip]="'authentication.resetPassword.infotips.newPassword' | translate"
                tooltipPosition="top"
                [positionTop]="-5" />
        </p-iconfield>
        @if (f.newPassword.touched && f.newPassword.errors?.required) {
            <small class="p-error">{{ 'authentication.resetPassword.validation.requiredPassword' | translate }}</small>
        }
        @if (f.newPassword.touched && f.newPassword.errors?.invalidPassword) {
            <small
                class="p-error"
                [innerHtml]="'authentication.resetPassword.validation.invalidPassword' | translate"></small>
        }
    </div>
    <div class="form-field">
        <label for="reset-confirm-password" class="form-field__label form-field__label--required">{{
            'authentication.resetPassword.form.confirmPassword' | translate
        }}</label>
        <p-iconfield>
            <p-inputicon styleClass="ms ms-key" />
            <input
                id="reset-confirm-password"
                [placeholder]="'authentication.common.placeholder.confirmPassword' | translate"
                type="password"
                formControlName="confirmPassword"
                autocomplete="off"
                pInputText
                [fluid]="true" />
        </p-iconfield>
        @if (f.confirmPassword.touched && f.confirmPassword.errors?.required) {
            <small class="p-error">{{ 'authentication.resetPassword.validation.requiredPassword' | translate }}</small>
        }
        @if (f.newPassword.touched && f.confirmPassword.touched && f.confirmPassword.errors?.mustMatch) {
            <small class="p-error">{{
                'authentication.resetPassword.validation.notMatchingPassword' | translate
            }}</small>
        }
    </div>
    <p-button
        type="submit"
        [loading]="loading"
        [label]="'authentication.resetPassword.button' | translate"
        [fluid]="true" />
</form>
<a routerLink="/auth/login" class="auth-back text-color-secondary text-sm">
    <span class="material-symbols-outlined icon-sm" aria-hidden="true">chevron_left</span>
    {{ 'authentication.common.navigationBack' | translate }}
</a>
